<template>
    <div class="main-content">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>题库管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" size="small" :model="formInline" class="user-search">
            <el-form-item label="科目类别：">
                <el-select clearable v-model="formInline.courseCategoryId">
                    <el-option v-for="item in courseList" :key="item.courseCategoryId" :label="item.courseCategoryName"
                        :value="item.courseCategoryId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="题目类型：">
                <el-select clearable v-model="formInline.questionType">
                    <el-option v-for="item in questionTypeList" :key="item.id" :label="item.label"
                        :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="题目：">
                <el-input size="small" v-model="formInline.questionTopicLike" placeholder="请输入题目"></el-input>
            </el-form-item>
            <el-form-item label="关键字：">
                <el-select clearable v-model="formInline.key">
                    <el-option v-for="item in tagList" :key="item.keyTagId" :label="item.key"
                        :value="item.key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" @click="search()">搜索</el-button>
                <el-button size="small" type="primary" @click="handleEdit()"
                    v-buttonAuth="'system:topic:add'">新建</el-button>
                <el-button size="small" type="primary" @click="dropdownBtn()"
                    v-buttonAuth="'system:topic:download'">下载模版</el-button>
                <el-button size="small" type="primary" @click="showExportDialog()"
                    v-buttonAuth="'system:topic:export'">批量导入</el-button>
                <el-button size="small" type="primary" @click="gokeys()"
                    v-buttonAuth="'system:topic:keys'">关键字管理</el-button>
            </el-form-item>
        </el-form>
        <div class="main-table">
            <my-table :columns="tableForm.customColumns" :tableData="tableForm.tableData" :loading="tableForm.isLoading"
                @selection-change="handleSelectionChange" @row-click="handleRowClick">
                <el-table-column align="center" prop="userSex" label="操作">
                    <template slot-scope="scope">
                        <!-- <el-button type="text" @click="handleEdit(1, scope.row)"
                            v-buttonAuth="'system:topic:edit'">编辑</el-button> -->
                        <el-button type="text" @click="handleEdit(2, scope.row)"
                            v-buttonAuth="'system:topic:details'">详情</el-button>
                        <el-popconfirm title="确认删除吗？" @confirm="deleteRow(scope.$index, scope.row)">
                            <el-button type="text" slot="reference" v-buttonAuth="'system:topic:delete'"
                                class="col-f4d">删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </my-table>
        </div>
        <div class="main-pagination">
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
        <el-dialog :title="title" :visible.sync="editFormVisible" custom-class="form-dialog" width="70%"
            @before-close='closeDialog("edit")'>
            <my-form :form-config="formConfig.formItems" ref="editForm" :formRules="formConfig.formRules"
                :disable-form="formConfig.disabled" @submit="submitForm" :dataForm="formConfig.dataForm">
                <template #questionImg>
                    <my-upload v-bind="uploadConfig" :imgUrl="formConfig.dataForm.questionImg"
                        @upload-success="handleSuccessAvatar" @beforeUpload="beforeUpload"
                        @upload-remove="handleRemoveAvatar">
                        <div slot="tip">
                            <span style="color:red;">注：支持图片格式PNG,JPEG,JPG,GIF</span>
                        </div>
                    </my-upload>
                </template>
                <template #questionOption>
                    <div v-for="(value, key, index) of formConfig.dataForm.questionOption" :key="key"
                        class="d-flex flex-align-center option-from">
                        <span>{{ key }}、</span>
                        <span v-if="formConfig.disabled">
                            {{ formConfig.dataForm.questionOption[key]
                            }}</span>
                        <el-input v-model="formConfig.dataForm.questionOption[key]" v-else
                            style="width:400px"></el-input>
                        &nbsp;&nbsp;
                        <i class="el-icon-delete" v-if="!formConfig.disabled" @click="deleteOptions(key)"></i>
                    </div>
                    <el-button type="primary" v-if="!formConfig.disabled" @click="addOptions()">+添加选项</el-button>
                </template>
                <template #keys>
                    <el-tag :key="tag" class="mg-lef5" v-for="tag in formConfig.dataForm.keys"
                        :closable="!formConfig.disabled" :disable-transitions="false" @close="handleClose(tag)">
                        {{ tag }}
                    </el-tag>
                    <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput"
                        size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
                    </el-input>
                    <el-button v-else class="button-new-tag" size="small" @click="showInput">增加关键字</el-button>
                </template>
            </my-form>
            <div slot="footer" class="dialog-footer" v-if="!formConfig.disabled">
                <el-button size="small" @click='editFormVisible = false'>取消</el-button>
                <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
        <!-- 导入 -->
        <my-import-dialog :exportUploadProperty="exportUploadProperty" :visible="exportDialog.visible" :file-size="100"
            :getResult="exportRes" @close="closeExportDialog"></my-import-dialog>
    </div>
</template>

<script>
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import myForm from '@/components/myForm.vue';
import myUpload from '@/components/myUpload.vue';
import { tagList } from '@/api/keys';
import store from '../../vuex/store';
import { capitalEnglishList, fileDownload, questionTypeList, organizationName } from "@/utils/util.js";
import courseApi from '@/api/onlineTraining/classification.js'
import { importRes, questionDetail, questionRemove, questionEdit, questionAdd, questionPage } from '@/api/topic.js'
import myImportDialog from "@/components/myImportDialog.vue";
export default {
    components: {
        MyTable,
        Pagination,
        myForm,
        myUpload,
        myImportDialog
    },
    data () {
        return {
            questionTypeList: questionTypeList,
            uploadConfig: {
                config: {
                    customAction: "/api/file/upload", // 替换成你的上传地址
                    accept: '.png,.jpg,jpeg',
                    listType: 'picture',
                    showFileList: false,
                    headers: {
                    },
                    disabled: false,
                    yourValue: [], // 双向绑定的值
                },
            },
            formInline: {
                courseCategoryId: '',
                questionType: '',
                questionTopicLike: '',
                key: '',
            },
            tableForm: {
                customColumns: [
                    { label: '所属机构', prop: 'name', formatter: () => { return organizationName } },
                    { label: '编码', prop: 'questionCode' },
                    { label: '科目类别', prop: 'courseCategoryName' },
                    { label: '题目类型', prop: 'questionTypeText' },
                    { label: '关键字', prop: 'keys', formatter: (item) => { return item.join(',') } },
                    { label: '题目内容', prop: 'questionTopic' },
                    { label: '分值', prop: 'questionScore' },
                ],
                tableData: [
                    // ...其他数据
                ],
                isLoading: false,
            },
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            editFormVisible: false, //控制编辑页面显示与隐藏
            title: '添加题目',
            inputVisible: false,
            inputValue: '',
            // 编辑与添加
            formConfig: {
                formItems: [
                    {
                        type: 'select', prop: 'courseCategoryId', label: '科目类别', options: [
                        ]
                    },
                    {
                        type: 'select', prop: 'keys', label: '关键字', options: [
                        ],
                        property: {
                            multiple: true,
                            'collapse-tags': true,
                        }
                    },

                    {
                        type: 'radio', prop: 'questionType', label: '题目类型', options: questionTypeList
                    },
                    {
                        type: 'textarea', prop: 'questionTopic', label: '题目内容', property: {
                            maxlength: 300,
                            'show-word-limit': true,
                        }
                    },
                    { prop: 'questionImg', label: '题目配图', },
                    { prop: 'questionOption', label: '选项', },
                    { type: 'number', prop: 'questionScore', label: '本题分值', min: 0 },
                    {
                        type: 'radio', prop: 'questionAnswer', hide: true, label: '正确答案', options: [
                        ]
                    },
                    {
                        type: 'textarea', prop: 'questionAnalysis', label: '题目解析', property: {
                            maxlength: 300,
                            'show-word-limit': true,
                        }
                    },
                    {
                        type: 'textarea', prop: 'questionLanguagePoint', label: '知识点出处', property: {
                            maxlength: 300,
                            'show-word-limit': true,
                        }
                    },
                ],
                formRules: {
                    courseCategoryId: [
                        { required: true, message: '请选择科目类别', trigger: 'change' },
                        // 可以添加其他验证规则
                    ],
                    keys: { required: true, message: '请输入关键字', trigger: 'change' },
                    questionType: [
                        { required: true, message: '请选择题目类型', trigger: 'change' },
                        // 可以添加其他验证规则
                    ],
                    questionTopic: { required: true, message: '请填写题目内容', trigger: 'blur' },
                    questionOption: {
                        required: true,
                        validator: (rule, value, callback) => {

                            if (Object.keys(value).length == 0) {
                                callback(new Error('请设置选项'));
                            } else {
                                for (const key in value) {
                                    if (Object.hasOwnProperty.call(value, key)) {
                                        const element = value[key];
                                        if (!element) {
                                            callback(new Error('请将选项填写完整'));
                                            return;
                                        }
                                    }
                                };
                                callback();
                            }
                        }, trigger: 'change'
                    },
                    questionScore: [
                        {
                            required: true,
                            validator: (rule, value, callback) => {
                                if (!value) {
                                    callback(new Error('请设置分值'));
                                }
                                callback();
                            }, trigger: 'blur'
                        },
                    ],
                    questionAnswer: { required: true, message: '请选择正确答案', trigger: 'change' },
                },
                dataForm: {
                    courseCategoryId: '',
                    questionType: 1,
                    questionTopic: '',
                    questionImg: '',
                    questionOption: {},
                    questionScore: 0,
                    questionAnswer: 'A',
                    questionAnalysis: '',
                    questionLanguagePoint: '',
                    keys: []
                }
            },
            courseList: [],
            exportUploadProperty: {
                config: {
                    customAction: "/api/edu/question/import", // 替换成你的上传地址
                    accept: '.xls,.xlsx',
                    headers: {
                    },
                    disabled: false,
                    limit: 1,
                    uploadData: {
                        // 可选的上传数据
                    },
                    yourValue: [], // 双向绑定的值
                },
            },
            exportDialog: {
                visible: false,
            },
            tagList: []
        }
    },
    watch: {
        'formConfig.dataForm.questionType': {
            handler (newVal, oldVal) {
                if (!this.formConfig.disabled) {
                    this.changeType()
                }
            },

        }
    },
    created () {
        this.getData();
        this.getDictionary();
    },
    methods: {
        search () {
            this.pageparm.currentPage = 1;
            this.getData();
        },
        async getData () {
            const params = {
                pageNum: this.pageparm.currentPage,
                pageSize: this.pageparm.pageSize,
                ...this.formInline,
            }
            const res = await questionPage(params);
            this.tableForm.tableData = res.data.records;
            this.pageparm.total = res.data.total;
        },
        async getDictionary () {
            const courseRes = (await courseApi.courseCategoryList({ pageNum: 1, pageSize: 999999, stateSign: true })).data;
            this.formConfig.formItems[0].options = courseRes.map(el => {
                return {
                    ...el,
                    id: el.courseCategoryId,
                    label: el.courseCategoryName
                }
            });

            const tagRes = (await tagList({ stateSign: true })).data;
            this.formConfig.formItems[1].options = tagRes.map(el => {
                return {
                    ...el,
                    id: el.key,
                    label: el.key
                }
            });
            this.tagList = tagRes;
            this.courseList = courseRes;

        },
        handleSelectionChange (selection) {
            console.log('选择发生变化：', selection);
        },
        handleRowClick (row) {
            console.log('点击行：', row);
        },
        handleEdit (index, row) {
            this.editFormVisible = true;
            this.formConfig.formItems[5].hide = false;
            this.formConfig.formItems[7].hide = true;
            this.uploadConfig.config.disabled = false;
            this.formConfig.disabled = false;
            if (row != undefined && row != 'undefined') {
                this.title = '修改题目'
                this.formConfig.dataForm = JSON.parse(JSON.stringify(row));
                // 修复关键字被删除 回显问题
                const options = this.formConfig.formItems[1].options.map(el => el.key)
                this.formConfig.dataForm.keys.map(el => {
                    if (!options.includes(el)) {
                        this.formConfig.formItems[1].options.push({
                            id: el,
                            label: el
                        })
                    }
                })

                this.setOptionsRadio()
                if (index == 2) {
                    this.title = '查看题目';
                    this.uploadConfig.config.disabled = true;
                    this.formConfig.disabled = true;
                    if (this.formConfig.dataForm.questionType == 3) {
                        this.$set(this.formConfig.dataForm, 'questionAnswer', JSON.parse(this.formConfig.dataForm.questionAnswer))
                        this.changeType(this.formConfig.dataForm.questionAnswer)
                    }
                } else {
                    if (this.formConfig.dataForm.questionType == 2) {
                        this.formConfig.dataForm.questionAnswer = this.formConfig.dataForm.questionAnswer.split(',')
                    }
                }
            } else {
                this.title = '添加题目'
                this.formConfig.dataForm = {
                    courseCategoryId: '',
                    questionType: 1,
                    questionTopic: '',
                    questionImg: '',
                    questionOption: {},
                    questionScore: 0,
                    questionAnswer: 'A',
                    questionAnalysis: '',
                    questionLanguagePoint: '',
                    keys: []
                };
                this.formConfig.formItems[7].options = [];

            }
            if (this.$refs.editForm) {
                this.$refs.editForm.$refs.form.resetFields();
            }
        },
        callFather (parm) {
            this.pageparm.currentPage = parm.currentPage
            this.pageparm.pageSize = parm.pageSize
            this.getData();

        },
        async deleteRow (index, row) {
            const archiveRes = await questionRemove([row.questionId]);
            this.$message.success(archiveRes.msg);
            this.getData();
        },
        // 关闭编辑、增加弹出框
        closeDialog (dialog) {
            this.$refs.editForm.$refs.form.resetFields();
            this.editFormVisible = false
        },
        submitForm (editData) {
            let data = JSON.parse(JSON.stringify(this.formConfig.dataForm));
            console.log(data);
            this.$refs.editForm.$refs.form.validate(async valid => {
                if (valid) {
                    if (data.questionType == 3) {
                        delete data.questionOption;
                    }
                    if (data.questionType === 2) {
                        data.questionAnswer = data.questionAnswer.sort().join()
                    };
                    const res = await (data.questionId ? questionEdit(data) : questionAdd(data));
                    this.closeDialog();
                    await this.getData();
                    this.$message.success(res.msg);
                } else {
                    return false
                }
            })
        },
        beforeUpload (rawFile, fun) {
            const get = _ => {
                if (!rawFile.name.includes('png') && !rawFile.name.includes('jpg') && !rawFile.name.includes('jpeg')) {
                    this.$store.state.loading = false;
                    this.$message({ message: '请上传正确的格式！', type: 'error' })
                    return false;
                } else if (rawFile.size / 1024 / 1024 > 5) {
                    this.$store.state.loading = false;
                    this.$message({ message: '超过5MB上传大小！', type: 'error' })
                    return false;
                }
                return true;
            };
            fun(get());
        },
        handleSuccessAvatar (data, file) {
            this.formConfig.dataForm.questionImg
                = envConfig.NODE_IMG_API + data.data.fileKey;
            this.$store.state.loading = false;
        },
        handleRemoveAvatar (file, fileList) {
            this.formConfig.dataForm.questionImg = ''
        },
        changeType (questionAnswer = true) {
            this.setOptionsRadio();
            this.formConfig.formItems[5].hide = false;

            switch (this.formConfig.dataForm.questionType) {
                case 1:
                    this.formConfig.dataForm.questionAnswer = 'A';
                    break;
                case 2:
                    this.formConfig.dataForm.questionAnswer = typeof this.formConfig.dataForm.questionAnswer == 'object' ? this.formConfig.dataForm.questionAnswer : ['A']
                    break;
                case 3:
                    this.formConfig.formItems[5].hide = true;
                    this.formConfig.formItems[7].hide = false;
                    this.formConfig.dataForm.questionAnswer = questionAnswer;
                    this.formConfig.formItems[7].options = [
                        { label: '正确', id: true },
                        { label: '错误', id: false },
                    ]
                    break;
                default:
                    break;
            }
            this.$forceUpdate()
            this.chengTypeOptions()
        },
        addOptions () {
            const questionOption = JSON.parse(JSON.stringify(this.formConfig.dataForm.questionOption));
            for (const key in questionOption) {
                if (Object.hasOwnProperty.call(questionOption, key)) {
                    const element = questionOption[key];
                    if (!element) {
                        this.$message.warning('请将选项填写完整')
                        return;
                    }
                }
            };
            const newOptionIndex = capitalEnglishList[Object.keys(questionOption).length];
            questionOption[newOptionIndex] = '';
            this.formConfig.dataForm.questionOption = questionOption;
            this.setOptionsRadio()
        },
        deleteOptions (key) {
            delete this.formConfig.dataForm.questionOption[key];
            let index = 0;
            const questionOption = this.formConfig.dataForm.questionOption;
            const newQuestionOption = {};
            for (const iterator in questionOption) {
                newQuestionOption[capitalEnglishList[index]] = questionOption[iterator];
                index++;
            }
            this.formConfig.dataForm.questionOption = newQuestionOption;
            this.setOptionsRadio()
        },
        setOptionsRadio () {
            if (Object.keys(this.formConfig.dataForm.questionOption || {}).length > 0) {
                this.formConfig.formItems[7].hide = false;
                this.formConfig.formItems[7].options = Object.keys(this.formConfig.dataForm.questionOption).map((key) => {
                    return { label: key, id: key }
                })
            } else {
                this.formConfig.formItems[7].hide = true;
                this.formConfig.formItems[7].options = []
            };
            this.chengTypeOptions()
            this.$forceUpdate()
        },
        chengTypeOptions () {
            switch (this.formConfig.dataForm.questionType) {
                case 2:
                    this.formConfig.formItems[7].type = 'checkbox';
                    break;
                default:
                    this.formConfig.formItems[7].type = 'radio';
                    break;
            }
        },
        dropdownBtn (index, data) {
            // TODO：process报错， 换成envConfig
            fileDownload(envConfig.NODE_API + '/templates/题库批量导入模板.xlsx', '题库批量导入模板.xlsx');
        },
        showExportDialog () {
            this.exportDialog.visible = true
            this.exportDialog.tableData = { total: 0, failCnt: 0 };
            this.exportUploadProperty.config.yourValue = [];
        },
        closeExportDialog () {
            this.exportDialog.visible = false;
            this.getData();
            this.exportUploadProperty.config.yourValue = [];
        },
        exportRes () {
            return importRes()
        },
        handleClose (tag) {
            this.formConfig.dataForm.keys.splice(this.formConfig.dataForm.keys.indexOf(tag), 1);
        },

        showInput () {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        handleInputConfirm () {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.formConfig.dataForm.keys.push(inputValue);
            }
            this.inputVisible = false;
            this.$refs.editForm.$refs.form.validateField('keys');
            this.inputValue = '';
        },
        gokeys () {
            this.$router.push({
                path: '/training/keys'
            })
        }
    }

}
</script>

<style lang="scss" scoped>
.user-search {
    margin-top: 20px;
}

.option-from {
    font-size: 14px;
    margin-bottom: 10px;
    color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/views/training/topicVendor.vue